export const validatePriceRange = (priceFrom: string, priceTo: string): boolean => {
    if (priceFrom && priceTo) {
      return parseInt(priceFrom) < parseInt(priceTo);
    }
    
    return true;
  };

//remove later to utili package
  export const isValidNumericInput = (value: string): boolean => {
    return /^\d*$/.test(value);
  };